<template>
  <div id="question-input">
    <label v-if="type === 'text'" class="textarea flex flex-direction-column">
      <span class="text-left"><strong>Digite aqui(opcional)</strong></span>
      <textarea
        :id="inputId"
        class="padding-10 textarea__camp font__size--3 margin-y-5"
        :value="value"
        @input="(event) => $emit('input', event.target.value)"
      />
    </label>

    <VInput
      v-else
      class="input-question"
      :value="value"
      @input="(event) => $emit('input', event)"
      :maxlength="maxLength"
      :error-message="error"
      :placeholder="placeHolder"
      :inputmode="inputMode"
    />
  </div>
</template>

<script>
export default {
  name: 'QuestionInput',
  props: {
    inputId: String,
    type: String,
    value: String,
    maskType: String,
    error: String,
  },
  computed: {
    maxLength() {
      switch (this.maskType) {
        case 'height':
          return 4;
        case 'date':
          return 10;
        case 'time':
          return 5;
        case 'text':
          return null;
        default:
          return 3;
      }
    },
    placeHolder() {
      if (this.maskType === 'time') {
        return '00:00';
      }
      return '';
    },
    inputMode() {
      const numeric = ['picker', 'time'];
      // this.type is in numeric array?
      return numeric.indexOf(this.type) !== -1 ? 'numeric' : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.textarea {
  &__camp {
    width: 298px;
    height: 87px;
    border-radius: 4px;
    border: 1px solid #e1e4ea;
  }
}

</style>

<style lang="scss">

.input-question {
  width: 115px!important;
  border-radius: 4px;
  background-color: white;

  input[type="text"].input-component__camp {
    border: 1px solid #E1E4EA;
    background-color: white!important;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: 0.005em;
    padding: 19px 15px;
    text-align: center;
    width: 100%;
    border-radius: 4px;
    color: #A0A9BA;
  }
}
</style>
